import React from 'react';
import { TSize } from '../../../types/types';

interface ISpacingProps {
    children?: React.ReactNode;
    marginSpacing: TSize;
    paddingSpacing: TSize;
    stretch?: boolean;
}

export const Spacing: React.FC<ISpacingProps> = ({ children, marginSpacing, paddingSpacing, stretch = true }) => {
    return <div className={`spacing  margin-spacing-${marginSpacing} padding-spacing-${paddingSpacing}`}>{children}</div>;
};
